import { createFileRoute } from "@tanstack/react-router";
import { TransportPage, transportHead } from "@/pages/TransportPage";

export const Route = createFileRoute("/en/industries/transport-logistics")({
  head: () => transportHead("en"),
  component: () => <TransportPage locale="en" />,
});
